var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', [_c('div', {
    staticClass: "table-wrapper"
  }, [_c('b-table', {
    staticClass: "mb-0",
    attrs: {
      "id": "table",
      "responsive": "",
      "small": "",
      "items": _vm.invitedUsers,
      "fields": _vm.getTableFields
    },
    scopedSlots: _vm._u([{
      key: "cell(actions)",
      fn: function (row) {
        return [_c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal",
            value: `remove-modal${row.item.id}`,
            expression: "`remove-modal${row.item.id}`"
          }],
          staticClass: "delete-btn ml-2",
          attrs: {
            "variant": "variant"
          }
        }, [_c('img', {
          attrs: {
            "src": require("@/assets/customer-project/delete.svg"),
            "alt": "delete"
          }
        })]), _c('confirmation-modal', {
          attrs: {
            "id": `remove-modal${row.item.id}`,
            "title-key": "event-editors.warning"
          },
          on: {
            "on-click-yes": function ($event) {
              return _vm.onRemove(row.item);
            }
          },
          scopedSlots: _vm._u([{
            key: "body-text",
            fn: function () {
              return [_c('p', {
                staticClass: "mb-3 text-center"
              }, [_vm._v(" " + _vm._s(_vm.$t('event-editors.warning-message', row.item)) + " ")])];
            },
            proxy: true
          }], null, true)
        })];
      }
    }])
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }